<div *ngIf="!showDiv && !routeParam && !isLoadingRequestSatisfaction">
	<div class="satisfaction-container" *ngIf="!isLoadingLabels">
		<div *ngIf="isLoadingCustom">
			<div class="custom-satisfaction" *ngFor="let item of customList">
				<span class="label">{{ item.question }}</span>
				<div class="button-container">
					<div
						class="button"
						[ngClass]="{ selected: selectedOption[item.id] === item.question_options.option1 }"
						(click)="selectedOption[item.id] = item.question_options.option1"
						*ngIf="item.question_options.option1 !== ''">
						{{ item.question_options.option1 }}
					</div>
					<div
						class="button"
						[ngClass]="{ selected: selectedOption[item.id] === item.question_options.option2 }"
						(click)="selectedOption[item.id] = item.question_options.option2"
						*ngIf="item.question_options.option2 !== ''">
						{{ item.question_options.option2 }}
					</div>
					<div
						class="button"
						[ngClass]="{ selected: selectedOption[item.id] === item.question_options.option3 }"
						(click)="selectedOption[item.id] = item.question_options.option3"
						*ngIf="item.question_options.option3 !== ''">
						{{ item.question_options.option3 }}
					</div>
					<div
						class="button"
						[ngClass]="{ selected: selectedOption[item.id] === item.question_options.option4 }"
						(click)="selectedOption[item.id] = item.question_options.option4"
						*ngIf="item.question_options.option4 !== ''">
						{{ item.question_options.option4 }}
					</div>
					<div
						class="button"
						[ngClass]="{ selected: selectedOption[item.id] === item.question_options.option5 }"
						(click)="selectedOption[item.id] = item.question_options.option5"
						*ngIf="item.question_options.option5 !== ''">
						{{ item.question_options.option5 }}
					</div>
				</div>
				<div class="comment-container" *ngIf="item.comment === true || item.comment === 1">
					<span class="label">{{ labels.lbl_comentario }}</span>
					<textarea
						rows="4"
						placeholder="{{ labels.lbl_comentario_opcional }}"
						[value]="selectedComment[item.id] ?? ''"
						(input)="selectedComment[item.id] = $event.target.value"></textarea>
				</div>
				<hr />
			</div>
		</div>

		<span class="label">{{ labels.lbl_chamado_vc_considera }}? *</span>
		<div class="button-container">
			<div
				class="button no"
				[ngClass]="{ pressed: !isThisRequestFinished && isThisRequestFinished != null }"
				(click)="isThisRequestFinished = false">
				{{ labels.lbl_geral_nao }}
			</div>
			<div class="button yes" [ngClass]="{ pressed: isThisRequestFinished }" (click)="isThisRequestFinished = true">
				{{ labels.lbl_geral_sim }}
			</div>
		</div>
		<span class="label" *ngIf="!hideRequestSatisfaction || !hideRequestSatisfaction"
			>{{ labels.lbl_chamado_qual_grau_satisfacao }}? *</span
		>
		<div class="button-container" *ngIf="!hideRequestSatisfaction || !hideRequestSatisfaction">
			<div
				class="button unsatisfied"
				[ngClass]="{ pressed: satisfactionLevel === 'Unsatisfied' }"
				(click)="satisfactionLevel = 'Unsatisfied'">
				{{ labels.lbl_geral_insatisfeito }}
			</div>
			<div
				class="button satisfied"
				[ngClass]="{ pressed: satisfactionLevel === 'Satisfied' }"
				(click)="satisfactionLevel = 'Satisfied'">
				{{ labels.lbl_geral_satisfeito }}
			</div>
			<div
				class="button verysatisfied"
				[ngClass]="{ pressed: satisfactionLevel === 'Very Satisfied' }"
				(click)="satisfactionLevel = 'Very Satisfied'">
				{{ labels.lbl_geral_muito_satisfeito }}
			</div>
		</div>

		<div class="label" *ngIf="!hideRequestSatisfaction || !hideRequestSatisfaction">{{ labels.lbl_leave_a_comment }} *</div>
		<textarea
			rows="4"
			[value]="commentary"
			(input)="commentary = $event.target.value"
			*ngIf="!hideRequestSatisfaction || !hideRequestSatisfaction"></textarea>

		<div class="button-container" style="margin-top: 10px">
			<div
				class="button submit"
				[ngClass]="{
					disabled:
						((satisfactionLevel === 'Unsatisfied' || !isThisRequestFinished) && commentary.trim() === '') ||
						isThisRequestFinished === null ||
						satisfactionLevel === null ||
						isLoadingSubmit,
				}"
				(click)="submitSatisfaction()">
				{{ labels.lbl_geral_enviar }}&nbsp;<cpi-dot-bounce-loading-effect
					*ngIf="isLoadingSubmit"
					[color]="'var(--const-white)'"></cpi-dot-bounce-loading-effect>
			</div>
		</div>
		<div class="button-container">
			<div class="button" (click)="goTo('request/' + requestId)">
				{{ labels.lbl_clique_aqui_para_chamado }}
			</div>
		</div>
		<div class="button-container">
			<div class="button" (click)="openModalEvaluationMSP()">{{ labels.lbl_geral_avaliar }} MySupport</div>
		</div>
	</div>

	<div class="loading-container" *ngIf="isLoadingLabels">
		<cpi-svg-gears></cpi-svg-gears>
		<div>{{ labels.lbl_edocs_carregando }}!</div>
	</div>
</div>

<div class="satisfaction-page-container container" *ngIf="routeParam">
	<div class="logos"><img src="assets/images/Atos.svg" /></div>

	<div class="satisfaction">
		<div class="title">
			<p>{{ labels.lbl_geral_obrigado_avaliacao }}</p>
			<p>{{ labels.lbl_geral_avaliacao_importante }}</p>
		</div>

		<div class="message">MySupport</div>
	</div>
</div>

<div
	class="evaluation-msp-modal evaluation-msp-modal-extremity-close"
	id="modalClose"
	(click)="modalClose($event, false)"
	*ngIf="isOpenModalEvaluationMSP">
	<div class="evaluation-msp-modal-content">
		<span class="evaluation-msp-modal-close" (click)="modalClose($event, true)"><fa-icon [icon]="faIcon.faXmark"></fa-icon></span>
		<app-mysupport-evaluation></app-mysupport-evaluation>
	</div>
</div>

<img class="blue-satisfaction-ball" src="assets/images/BolinhaAzul.svg" *ngIf="!showDiv && !routeParam && !isLoadingRequestSatisfaction" />
<img
	class="orange-satisfaction-ball"
	src="assets/images/BolinhaRosa.svg"
	*ngIf="!showDiv && !routeParam && !isLoadingRequestSatisfaction" />
